import { createSelector } from '@ngrx/store'

export const getCompoundsState = createSelector(
  (state: any) => state.compounds,
  (state: any) => state.get('list'),
)

export const getUpdateCompoundState = createSelector(
  (state: any) => state.compounds,
  (state: any) => state.get('update'),
)

export const getCreateCompoundState = createSelector(
  (state: any) => state.compounds,
  (state: any) => state.get('create'),
)
